module.exports = __webpack_public_path__ + "02_very_short_black.3fe718e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_very_short_black.png
// module id = k8oL
// module chunks = 0